import React from 'react';
import { Seo } from '../components/Seo';

const Block = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl md:text-2xl font-bold text-[#C5A880] mb-4">{title}</h2>
    <div className="space-y-3 text-[#EADBC8]/80 leading-relaxed text-sm md:text-base">{children}</div>
  </div>
);

const Privacy = () => (
  <div className="min-h-screen bg-[#1F1A17]">
    <Seo
      title="Privacy Policy"
      description="How Mayden Films collects and uses personal information for enquiries, bookings and image delivery, in line with Australian privacy principles."
      path="/privacy"
    />
    <section className="pt-36 pb-12 bg-gradient-to-br from-[#1F1A17] via-[#2A2420] to-[#1F1A17]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl sm:text-5xl font-bold text-[#EADBC8] mb-4">Privacy Policy</h1>
        <p className="text-[#EADBC8]/60">How we handle your information.</p>
      </div>
    </section>

    <section className="py-16 bg-[#1A1612]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Block title="Why we collect information">
          <p>Contact details are collected so we can respond to your enquiry and manage your booking.</p>
        </Block>
        <Block title="Guest image delivery">
          <p>Guest email addresses and mobile numbers entered at the booth to receive images are used only to deliver those images, unless the guest separately consents to marketing.</p>
        </Block>
        <Block title="No automatic marketing">
          <p>Mayden Films does not automatically add clients or guests to any marketing list. Marketing only happens with separate, explicit consent.</p>
        </Block>
        <Block title="Public Portfolio">
          <p>Our public Portfolio only displays images that clients have given permission to share.</p>
        </Block>
        <Block title="Use of images in advertising">
          <p>Event images will not be used in Mayden Films advertising without your permission. Images involving children require appropriate permission before any promotional use. Marketing-approved images are stored separately from routine event files.</p>
        </Block>
        <Block title="Requesting removal">
          <p>You may request earlier gallery removal, subject to legitimate business and record-keeping requirements.</p>
        </Block>
        <Block title="Contact">
          <p>For any privacy questions, email <a href="mailto:mf.maydenfilms@gmail.com" className="text-[#C5A880] hover:underline">mf.maydenfilms@gmail.com</a>.</p>
        </Block>
      </div>
    </section>
  </div>
);

export default Privacy;
